import Api from './api';

export const getById = async (id) => { 
  let data = []
  await Api.get(`/calledservicesettingsvalidation/${id}`)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })
  return data
};

export const getByIdWithoutIncludes = async (id) => { 
  let data = []
  await Api.get(`/calledservicesettingsvalidation/${id}/withoutincludes`)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })
  return data
};

export const getByIdWithAttachmentIncludes = async (id) => { 
  let data = []
  await Api.get(`/calledservicesettingsvalidation/${id}/withattachmentincludes`)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })
  return data
};

export const getAllByCalledServiceSettingsId = async (calledServiceSettingsId) => { 
  let data = []
  await Api.get(`/calledservicesettingsvalidation/all/calledservicesettings/${calledServiceSettingsId}`)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })
  return data
};

export const getAllByCalledServiceSettingsIdWithoutIncludes = async (calledServiceSettingsId) => { 
  let data = []
  await Api.get(`/calledservicesettingsvalidation/all/calledservicesettings/${calledServiceSettingsId}/withoutincludes`)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })
  return data
};

export const getAllByCalledServiceSettingsIdWithAttachmentIncludes = async (calledServiceSettingsId) => { 
  let data = []
  await Api.get(`/calledservicesettingsvalidation/all/calledservicesettings/${calledServiceSettingsId}/withattachmentincludes`)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })
  return data
};

export const paginate = async (page, search, calledServiceSettingsId, field, size = 10) => { 
  let data = []

  let url = `/calledservicesettings/paginate/calledservicesettings/${calledServiceSettingsId}?page=${page}&size=${size}`
  if (search != '' && field != 0)
    url += `&search=${search}&field=${field}`

  await Api.get(url)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })
  return data
}

export const addItem = async (formData) => { 
  let data = []
  await Api.post(`/calledservicesettingsvalidation`, formData, { headers: { "Content-Type": "multipart/form-data" } })
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })
  return data
}

export const editItem = async (formData) => { 
  let data = []
  await Api.put(`/calledservicesettingsvalidation`, formData, { headers: { "Content-Type": "multipart/form-data" } })
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })
  return data
}

export const deleteAttachmentById = async (id) => { 
  let data = []
  await Api.put(`/calledservicesettingsvalidation/${id}/deleteattachment`)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })
  return data
}

export const deleteItem = async (id) => { 
  let data = []
  await Api.delete(`/calledservicesettingsvalidation/${id}`)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })
  return data
}

export const deleteItems = async (idList) => { 
  let data = []
  await Api.delete(`/calledservicesettingsvalidation/items/${idList}`)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })
  return data
}